import { useCallback } from "react";
import FilterChatForm from "./FilterChatForm";
import { Button, Form, Popover, Tooltip } from "antd";
import { BsFilter } from "react-icons/bs";
import { formatDateDB } from "utils/formatting";
import { isEmpty, isEqual } from "lodash-es";

const PopOverFilter = ({ data, onSubmit }) => {
  const [form] = Form.useForm();

  const openChangeHandler = useCallback(
    async (visible) => {
      if (!visible) {
        const values = await form.validateFields();
        const newValues = {
          agent_id: values.agent_id,
          contact_id: values.contact_id,
          phone_number_id: values.phone_number_id,
          date_from: "",
          date_to: "",
          tag_ids: values.tag_ids ? values.tag_ids.join(",") : null,
          conv_status_id:
            values.conv_status_id !== null &&
            values.conv_status_id !== undefined &&
            values.conv_status_id !== ""
              ? values.conv_status_id
              : null,
        };
        if (Array.isArray(values.date) && !isEmpty(values.date)) {
          if (!isEmpty(values.date[0])) {
            newValues.date_from = formatDateDB(values.date[0]);
          }
          if (!isEmpty(values.date[1])) {
            newValues.date_to = formatDateDB(values.date[1]);
          }
        } else {
          newValues.date_from = "";
          newValues.date_to = "";
        }

        if (!isEqual(data, newValues)) {
          onSubmit({ ...newValues, page: 1 });
        }
      }
    },
    [data, form, onSubmit]
  );

  return (
    <Popover
      content={<FilterChatForm form={form} data={data} />}
      // title="Filter"
      trigger="click"
      form={form}
      onOpenChange={openChangeHandler}
      classNames={{ body: "w-[390px]" }}
    >
      <Tooltip title="Filter">
        <Button
          type="text"
          icon={<BsFilter className="text-[#263238] opacity-70" size={22} />}
          shape="circle"
        />
      </Tooltip>
    </Popover>
  );
};

export default PopOverFilter;
